var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout sale"},[_c('div',{staticClass:"top_nav sale"},[_c('menu-top-header-sale')],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }